import { OnBoardingScreenOptions } from '@mindly/ui-components';

export const SCREEN_OPTIONS_WITHOUT_NEXT_BUTTON = [
  OnBoardingScreenOptions.SINGLE_SELECT,
  OnBoardingScreenOptions.SINGLE_IMAGE_SELECT,
  OnBoardingScreenOptions.SINGLE_ROUND_IMAGE_SELECT,
  OnBoardingScreenOptions.LOADER,
  OnBoardingScreenOptions.LIST_LOADER,
];
